import { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";
import Seo from "@/components/Seo";
import { Kicker } from "@/components/form";
import { api, API } from "@/lib/api";

export default function Downloads() {
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get("/downloads").then((r) => setDocs(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="downloads-page" className="bg-navy-900 min-h-screen">
      <Seo title="Download-Center" description="Broschüren, Formulare und Informationsmaterial von VM-FFM.DE zum Download." path="/downloads" />
      <section className="pt-40 pb-24">
        <div className="max-w-4xl mx-auto px-6">
          <Kicker>Download-Center</Kicker>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold tracking-tighter text-white leading-none">Broschüren & Formulare</h1>
          <p className="mt-5 text-slate-300">Alle wichtigen Dokumente zum Herunterladen.</p>
          <div className="mt-10 space-y-3">
            {docs.map((d) => (
              <a key={d.id} href={`${API}/documents/${d.id}/download`} target="_blank" rel="noreferrer" data-testid={`download-${d.id}`}
                className="flex items-center justify-between bg-navy-800 border border-white/10 rounded-md px-5 py-4 hover:border-gold-500/40 transition-colors">
                <div className="flex items-center gap-3"><FileText size={20} className="text-gold-500" /><div><p className="text-white text-sm font-medium">{d.original_filename}</p><p className="text-xs text-slate-500">{d.category} · {(d.size / 1024).toFixed(0)} KB</p></div></div>
                <Download size={18} className="text-slate-400" />
              </a>
            ))}
            {docs.length === 0 && <p className="text-slate-500">Aktuell stehen keine öffentlichen Downloads bereit.</p>}
          </div>
        </div>
      </section>
    </div>
  );
}
